import { z } from "@hono/zod-openapi";

export const FeedbackSchema = z
  .object({
    id: z.string().nanoid(),
    score: z
      .number()
      .min(0)
      .max(1)
      .describe(
        "The score of the feedback - 0 for 'thumbs down', 1 for 'thumbs up'",
      ),
    chatId: z.string().nanoid().nullable(),
    userId: z.string().uuid().nullable(),
    messageId: z.string().nanoid().nullable(),
    text: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
  })
  .describe("A single feedback object");

export type Feedback = z.infer<typeof FeedbackSchema>;

export const GetFeedbackResponseSchema = z
  .object({
    feedback: FeedbackSchema,
  })
  .describe("Response payload associated with the feedback get endpoint");

export type GetFeedbackResponse = z.infer<typeof GetFeedbackResponseSchema>;

export const CreateFeedbackRequestSchema = z
  .object({
    id: z
      .string()
      .nanoid()
      .describe(
        "client-set id for the feedback - helpful for optimistic updates",
      ),
    score: z.number().min(0).max(1),
    chatId: z.string().nanoid(),
    messageId: z.string().nanoid(),
    text: z.string().optional(),
  })
  .describe("Request payload associated with the chat create endpoint");
export type CreateFeedbackRequest = z.infer<typeof CreateFeedbackRequestSchema>;

export const CreateFeedbackResponseSchema = z
  .object({
    feedback: FeedbackSchema,
  })
  .describe("Response payload associated with the feedback create endpoint");
export type CreateFeedbackResponse = z.infer<
  typeof CreateFeedbackResponseSchema
>;

export const ListFeedbackResponseSchema = z
  .object({
    feedbacks: FeedbackSchema.array(),
  })
  .describe("Response payload associated with the feedback list endpoint");
export type ListFeedbackResponse = z.infer<typeof ListFeedbackResponseSchema>;
